<template>
  <div v-if="false" class="cart_row individual">
    <!-- <pre>selectedTimes: {{selectedTimes}}</pre> -->
    <div class="flex">
      <!-- <figure
        @click.prevent="modifyLink"
        :style="'background-image: url(' + photo + ')'"
      ></figure> -->
      <img :src="photo" @click.prevent="modifyLink" class="cart-image" />
      <!--      <router-link class="hgroup" :to="link" activeClass="active"-->
      <!--        >Test</router-link-->
      <!--      >-->
      <a class="text_size-large" @click.prevent="modifyLink">
        <div v-if="containsPartnerExperience">
          <partner-experience-tag />
        </div>
        <h4 class="-flex_bottom">
          <span>{{ product.Name }}</span
          ><span class="ml-1 bullet">Edit</span>
        </h4>

        <section class="each_time" v-for="selectedTime in selectedTimes" :key="'cart-row-' + product.OrderEntityKey + '-' + selectedTime.Value">
          <div class="r text-slate text_size-small" style="-padding-right: 30px;" v-if="selectedTime.Participants">
            {{ selectedTime.AppointmentDate }}
            <!-- {{ selectedTime.AppointmentDate | moment("ddd, MMM DD, YYYY") }} -->
            <span style="white-space: nowrap;">at {{ selectedTime.DisplayName }}</span>
          </div>

          <!--          <div-->
          <!--            class="r flex text-slate"-->
          <!--            v-if="product.Activities[0].IsPrivateTour"-->
          <!--          >-->
          <!--            <span>{{ selectedTime.Participants }} private guests...</span>-->
          <!--            <span>-->
          <!--              <currency :fixed="true" :value="selectedTime.SubTotal" />-->
          <!--            </span>-->
          <!--          </div>-->

          <!--          <div-->
          <!--            v-else-->
          <!--            class="r flex text-slate cart_rate"-->
          <!--            v-for="rate in selectedTime.Rates"-->
          <!--          >-->
          <!--            <span>{{ rate.Name }}</span>-->
          <!--            <span><currency :fixed="true" :value="rate.Price" /> </span>-->
          <!--            <span-->
          <!--              ><currency :fixed="true" :value="rate.Price * rate.Participants"-->
          <!--            /></span>-->
          <!--          </div>-->

          <table class="cart_pricing text-slate text_size-small">
            <tr
              v-for="rate in selectedTime.Rates"
              v-show="rate.IsPrivateTourRate & (rate.Participants > 0)"
              :key="product.OrderEntityKey + '-selectedTimeValue-isPrivateRate-' + selectedTime.Value + '-rate-' + rate.EntityHierarchyRateKey"
            >
              <td class="pr-1">
                {{ rate.Name }}
                <span class="text-pencil-light"> &nbsp;<currency :fixed="true" :value="rate.Price" /> x&nbsp;{{ rate.Participants }}&nbsp; </span>
              </td>
              <td align="right">
                <currency :fixed="true" :value="rate.Price * rate.Participants" />
              </td>
            </tr>

            <tr
              v-for="rate in selectedTime.Rates"
              v-show="!rate.IsPrivateTourRate & (rate.Participants > 0)"
              :key="product.OrderEntityKey + '-selectedTimeValue-' + selectedTime.Value + '-rate-' + rate.EntityHierarchyRateKey"
            >
              <td class="pr-1">
                {{ rate.Name }}
                <span class="text-pencil-light">
                  <span v-show="rate.Price > 0">&nbsp;</span><currency :fixed="true" :value="rate.Price" v-show="rate.Price > 0" /> x&nbsp;{{
                    rate.Participants
                  }}&nbsp;
                </span>
              </td>
              <td align="right">
                <currency :fixed="true" :value="rate.Price * rate.Participants" v-show="rate.Price > 0" />
              </td>
            </tr>

            <tr v-for="(add, i) in selectedTime.AddOns.filter((a) => !a.IsDeleted)" :key="product.OrderEntityKey + '-' + add.ProductKey + '-' + i">
              <td class="pr-1">
                {{ add.AddOnName }}
                <span class="text-pencil-light">
                  <span v-if="add.Quantity && !add.IsBoolean">
                    &nbsp;<currency :fixed="true" :value="price(add)" v-if="price(add)" />
                    <div v-else>Free</div>
                  </span>

                  {{ add.Quantity && !add.IsBoolean ? " x " + add.Quantity : "" }}
                </span>
              </td>
              <td align="right" style="width: 6%;">
                <currency :fixed="true" :value="price(add) * add.Quantity" v-if="price(add)" />
                <div v-else>Free</div>
              </td>
            </tr>
          </table>

          <!--          <pre>time.PickupLocation {{ time.PickupLocation }}</pre>-->
          <!-- <pre>product.IsPrivateTour: {{product.IsPrivateTour}} Don't use this one!!!</pre>
          <pre>product.Activities[0].IsPrivateTour: {{product.Activities[0].IsPrivateTour}}</pre>-->
        </section>
      </a>
    </div>
    <template v-for="selectedTime in selectedTimes">
      <p
        v-if="selectedTime.PickupLocation"
        :key="'transportation-times-' + selectedTime.OrderEntityTimeKey"
        class="bg-gray mt-3 pl-2 pr-2 pt-2 pb-2 border_radius flex_start"
      >
        Transportation -
        {{ selectedTime.PickupLocation.DepartureDisplayTime }} pickup at
        {{ selectedTime.PickupLocation.LocationName }}
        <br />
        Confirmation email will give exact details.
        <br />
        Payment due upon arrival.
      </p>
    </template>
    <a class="delete_button" v-on:click.prevent="confirmRemoveFromCart({ ...product, isPackage: false })">&#10006;</a>
  </div>
  <div v-else class="cart-row-item">
    <!-- REMOVE BUTTON -->
    <a class="delete_button" v-on:click.prevent="confirmRemoveFromCart({ ...product, isPackage: false })"></a>
    <picture class="activity-image" @click.prevent="modifyLink">
      <img :src="photo" />
    </picture>
    <div class="activity-desc" @click.prevent="modifyLink">
      <!-- ACTIVITY NAME -->
      <div class="activity-name text_size-large text_style-bold" @click.prevent="modifyLink">
        <div>{{ product.Name }}</div>
      </div>
      <!-- ACTIVITY TIME -->
      <div
        v-for="(selectedTime, idx) in selectedTimes"
        :key="'cart-row-' + product.OrderEntityKey + '-' + selectedTime.Value"
        :style="idx > 0 ? 'margin-top: 8px' : ''"
        class="activity-timeslot"
      >
        <div v-if="selectedTime.Participants && selectedTime.AppointmentTypeKey != 3" class="text_size-medium-small">
          <span>{{ selectedTime.AppointmentDate }}</span>
          <span style="white-space: nowrap;" v-if="selectedTime.AppointmentTypeKey != 3 && selectedTime.AppointmentTypeKey != 2"
            >&nbsp;at {{ selectedTime.DisplayName }}</span
          >
        </div>

        <!-- ACTIVITY RATE INFORMATION -->
        <div class="activity-rates text_size-medium-small">
          <!-- PRIVATE TOUR RATE -->
          <div
            v-for="rate in selectedTime.Rates"
            :key="product.OrderEntityKey + '-selectedTimeValue-isPrivateRate-' + selectedTime.Value + '-rate-' + rate.EntityHierarchyRateKey"
            v-show="rate.IsPrivateTourRate & (rate.Participants > 0)"
          >
            <span class="entry">
              {{ rate.Name
              }}<span class="entry-quantity">
                <currency :fixed="true" :value="rate.Price" v-if="rate.Participants > 1" />
                x
                {{ rate.Participants }}
              </span>
            </span>
            <span class="subtotal">
              <currency :fixed="true" :value="rate.Price * rate.Participants" />
            </span>
          </div>
          <!-- INDIVIDUAL RATE -->
          <div
            class="rate-entry"
            v-for="rate in selectedTime.Rates"
            v-show="!rate.IsPrivateTourRate & (rate.Participants > 0)"
            :key="product.OrderEntityKey + '-selectedTimeValue-' + selectedTime.Value + '-rate-' + rate.EntityHierarchyRateKey"
          >
            <span class="entry">
              {{ rate.Name
              }}<span class="entry-quantity">
                <currency :fixed="true" :value="rate.Price" v-if="rate.Participants > 1 && rate.Price > 0" />
                x
                {{ rate.Participants }}
              </span>
            </span>
            <span class="subtotal">
              <currency :fixed="true" :value="rate.Price * rate.Participants" />
            </span>
          </div>
          <!-- ADD ON ITEMS -->
          <div
            class="rate-entry"
            v-for="(add, i) in selectedTime.AddOns.filter((a) => !a.IsDeleted)"
            :key="product.OrderEntityKey + '-' + add.ProductKey + '-' + i"
          >
            <div v-if="add.Variants.length" class="variant-entry">
              <span class="entry">{{ add.AddOnName }}</span>
              <ul class="variant-list">
                <li v-for="(v, j) in add.Variants" :key="j">
                  <span>{{ v.ProductName }} x {{ v.Quantity }}</span>
                  <currency :value="v.PublishedPrice * v.Quantity" />
                </li>
              </ul>
            </div>
            <div v-else class="rate-entry">
              <span class="entry"
                >{{ add.AddOnName }}
                <span class="entry-quantity" v-if="add.Quantity > 1">
                  <currency :fixed="true" :value="price(add)" v-if="price(add)" /><span v-else>Free</span> x
                  {{ add.Quantity }}
                </span></span
              >
              <span class="subtotal" v-if="add.Quantity">
                <currency :fixed="true" :value="price(add) * add.Quantity" v-if="price(add)" /><span v-else>Free</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PartnerExperienceTag from "@/components/PartnerExperienceTag.vue";

export default {
  components: { PartnerExperienceTag },
  name: "CartRowIndividual",
  props: ["product"],
  created() {
    // calc variant quantity
    this.product.Activities.forEach((act) => {
      act.SelectedTimes.forEach((t) => {
        t.AddOns.forEach((a) => {
          if (a.Variants && a.Variants.length) {
            a.Quantity = a.Variants.reduce((p, c) => (p += c.Quantity), 0);
            // a.PublishedPrice = a.Variants.reduce(
            // 	(p, c) => (p += c.Quantity * c.PublishedPrice),
            // 	0
            // );
          }
        });
      });
    });
  },
  mounted() {
    console.log("product", this.product);
  },
  methods: {
    ...mapActions(["confirmRemoveFromCart"]),
    price(v) {
      var discount = v.AddOnDiscount ? v.AddOnDiscount : 0;
      return v.Cost - discount;
    },

    modifyLink() {
      if (this.product.PackageKey) {
        this.$router.push({
          path: this.link,
          query: { pkg: this.product.PackageKey },
        });
      } else {
        this.$router.push({
          path: this.link,
        });
      }
    },
  },
  computed: {
    ...mapState(["order", "client"]),
    containsPartnerExperience() {
      return this.product.Activities.filter((act) => act.Owner_ClientLocationKey).length > 0;
    },
    link() {
      const identifier = this.product.OrderEntityKey;

      return (
        "/" +
        this.$route.params.client +
        "/activity" +
        "/modify" +
        "/" +
        identifier +
        "/" +
        (this.$route.params.clientAgentKey ? this.$route.params.clientAgentKey + "/start" : "n/start")
      );
    },
    guests() {
      //return this.product.Participants;

      let c = 0;

      this.product.Activities[0].SelectedTimes[0].Rates.forEach((rate) => {
        if (!rate.IsPrivateTourRate) {
          c = c + rate.Participants;
        }
      });

      if (c != this.product.Participants) {
        console.error("product.Participants is not accurate.");
      }

      return c;
    },
    selectedTimes() {
      if (this.product.Activities && this.product.Activities[0].SelectedTimes) {
        return this.product.Activities[0].SelectedTimes;
      }
      return false;
    },
    // date() {
    //   return this.$moment(this.product.Activities[0].AppointmentDate).format(
    //     "ddd, MMM D"
    //   );
    // },
    // time() {
    //   return this.product.Activities[0].SelectedTimes.length
    //     ? this.product.Activities[0].SelectedTimes[0].DisplayName
    //     : "";
    // },
    photo() {
      return this.product.PhotoDomain + "w_280,h_280,c_fill" + "/v" + this.product.PhotoVersion + this.product.PhotoFolder + "/original";
    },
  },
};
</script>

<style lang="scss" scoped>
.rate-entry {
  width: 100%;

  display: flex;
  justify-content: space-between;
}

.variant-entry {
  width: 100%;
}

.variant-list {
  margin: 0;
  padding: 0;
  padding-left: 16px;
  list-style: none;

  li {
    width: 100%;
    display: flex;
    justify-content: space-between;

    span:first-child {
      width: calc(80% - 16px);
    }
  }
}

.entry {
  max-width: 80%;
}

.entry-quantity {
  white-space: nowrap;
}

.activity-name {
  display: flex;
  align-items: center;
  max-width: 90%;

  &::after {
    content: "Edit";
    font-size: 10px;
    font-weight: 200;
    color: var(--highlight);
    border: 1px solid var(--highlight);
    border-radius: 3px;
    padding: 1px 3px;
    margin-left: 6px;
    visibility: hidden;
  }

  // mobile
  @media only screen and (max-width: 942px) {
    color: var(--highlight);

    &::after {
      content: "";
      border: none;
    }
  }
}

.activity-image {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  justify-content: center;

  > img {
    object-fit: scale-down;
  }
}

.rate-details {
  width: 100%;
}

.activity-desc,
.activity-timeslot,
.activity-rates {
  display: grid;
  grid-gap: 2px;
  color: #000;
}

.subtotal {
  // float: right;
}
</style>
